var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-card",
    [
      _c(
        "md-card-header",
        { staticClass: "md-card-header-icon md-card-header-green" },
        [
          _c(
            "div",
            { staticClass: "card-icon" },
            [_c("md-icon", [_vm._v("receipt_long")])],
            1
          ),
        ]
      ),
      _c("md-card-content", [
        !_vm.lines || _vm.lines.length === 0
          ? _c("p", { staticClass: "grayedout-text" }, [
              _vm._v("No item provided."),
            ])
          : _c(
              "div",
              [
                _c(
                  "md-table",
                  {
                    staticClass: "context-menu-support custom-paginated-table",
                  },
                  [
                    _c(
                      "md-table-row",
                      [
                        _c("md-table-head", [_vm._v("Description")]),
                        !_vm.isMobileView
                          ? _c("md-table-head", [_vm._v("Quantity")])
                          : _vm._e(),
                        !_vm.isMobileView
                          ? _c("md-table-head", [_vm._v("Unit Cost (Ex-Tax)")])
                          : _vm._e(),
                        _c("md-table-head", [_vm._v("Total Amount (Ex-Tax)")]),
                        _c("md-table-head", [_vm._v("Ref")]),
                        !_vm.isMobileView
                          ? _c("md-table-head", [_vm._v("Status")])
                          : _vm._e(),
                        _c("md-table-head", [_vm._v("Action")]),
                      ],
                      1
                    ),
                    _vm._l(_vm.lines, function (line, index) {
                      return _c(
                        "md-table-row",
                        { key: index },
                        [
                          _c("md-table-cell", [
                            _vm._v(_vm._s(line.description)),
                          ]),
                          !_vm.isMobileView
                            ? _c("md-table-cell", [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(line.quantity) +
                                    "\n                        "
                                ),
                                _c("span", { staticClass: "quantity-type" }, [
                                  _vm._v(_vm._s(line.quantityType)),
                                ]),
                              ])
                            : _vm._e(),
                          !_vm.isMobileView
                            ? _c("md-table-cell", [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm._f("currency")(
                                        line.unitPriceExTax,
                                        line.priceCurrency
                                      )
                                    ) +
                                    "\n                    "
                                ),
                              ])
                            : _vm._e(),
                          _c("md-table-cell", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm._f("currency")(
                                    line.unitPriceExTax * line.quantity,
                                    line.priceCurrency
                                  )
                                ) +
                                "\n                    "
                            ),
                          ]),
                          _c(
                            "md-table-cell",
                            [
                              line.stopId
                                ? _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: {
                                          name: "Stop Details",
                                          params: { stopId: line.stopId },
                                        },
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(line.stopRef) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                : line.shipmentId
                                ? _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: {
                                          name: "Shipment Details",
                                          params: {
                                            shipmentId: line.shipmentId,
                                          },
                                        },
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(line.shipmentRef) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                : line.tripId
                                ? _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: {
                                          name: "Trip Details",
                                          params: { tripId: line.tripId },
                                        },
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(line.tripRef) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          !_vm.isMobileView
                            ? _c("md-table-cell", [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(line.status) +
                                    "\n                    "
                                ),
                              ])
                            : _vm._e(),
                          _c(
                            "md-table-cell",
                            [
                              (line.stopId || line.shipmentId || line.tripId) &&
                              line.serviceId === null
                                ? _c("create-issue", {
                                    directives: [
                                      {
                                        name: "feature",
                                        rawName: "v-feature",
                                        value: _vm.FEATURE_NAMES.IssueTracking,
                                        expression:
                                          "FEATURE_NAMES.IssueTracking",
                                      },
                                    ],
                                    attrs: {
                                      "related-entity-type":
                                        _vm.$_issueRelatedEntityType(line),
                                      "related-entity-ref":
                                        _vm.$_issueRelatedEntityReference(line),
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                ),
              ],
              1
            ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }